import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { openModal, closeModal } from 'actions/modal';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal } from '@cuemath/comps';
import { Modal as WebCompsModal } from '@cuemath/web-comps';
import AddNewActivityCardModel from '../../modals/add-activity';
import AddSheetModal from '../../modals/add-sheet';
import AddTopicModal from '../../modals/add-sheet/add-filter';
import AssignTeacherModal from '../../modals/student-demo/assign-teacher';
import BulkRMAssignmentModal from '../../modals/bulk-rm-assignment-modal';
import ConfirmationModal from '../../modals/confirmation-modal';
import CourseClassLogActionModal from '../../modals/course-class-log-action-modal';
import CreateNewActivityModal from '../../modals/create-activity';
import DemoIncentives from '../../modals/demo-incentives';
import DemoSlotCreationModal from '../../modals/demo-slots-modal';
import EditActivityModal from '../../modals/edit-activity';
import EditFilterModal from '../../modals/add-sheet/edit-filter';
import EditStudentRegion from '../../modals/edit-student-region';
import EditStudentSlotModal from '../../modals/edit-student-slot';
import EditStudentUsernameModal from '../../modals/edit-student-username';
import EditStudentPhoneModal from '../../modals/edit-student-phone';
import EditStudentEmailModal from '../../modals/edit-student-email';
import ElectiveCoursesModal from '../../modals/elective-courses';
import FoundationPaymentModal from '../../modals/foundation-payment-modal';
import NewPaymentModal from '../../modals/new-payment-link-modal';
import ParentStudentModal from '../../modals/parent-student';
import PaymentConfirmModal from '../../modals/payment-data-upload/confirm-payment';
import PaymentDataModal from '../../modals/payment-data-upload';
import PaymentModal from '../../modals/payment-link-modal';
import PhoneModal from '../../modals/phone';
import RelationshipManagerModal from '../../modals/relationship-manager';
import ReviewConfirmModal from '../../modals/teacher-performance-review/review-confirmation';
import ReviewTypeModal from '../../modals/teacher-performance-review/review-type';
import SearchFilterModal from '../../modals/add-sheet/search-modal';
import StudentCourseEditModal from '../../modals/student-course-edit-modal';
import StudentCourseLogModal from '../../modals/student-course-log-modal';
import StudentFormModal from '../../modals/student-form';
import StudentPaymentModal from '../../modals/student-payments';
import StudentUpgradeModal from '../../modals/student-upgrade-form';
import StudentUpgradeV2Modal from '../../modals/student-upgrade-v2-form';
import StudentTransferClassesModal from '../../modals/student-transfer-classes-form';
import StudentConvertClassesToCreditModal from '../../modals/student-convert-classes-to-credit-form';
import StudentRevertUpgradePaymentLinkModal from '../../modals/student-revert-upgrade-payment-link-form';
import StudentTrialUpgradeModal from '../../modals/student-trial-upgrade-form';
import TableModal from '../../modals/table';
import TeacherCredForm from '../../modals/teacher-cred-form';
import BulkEditmodal from '../../modals/bulk-edit';
import TeacherFormModal from '../../modals/teacher-form';
import UpdateDemoModal from '../../modals/student-demo';
import OnlinePlansPricingManagementModal from '../../modals/online-plans';
import SuccessModal from '../../modals/success-modal';
import TranscriptModal from '../../modals/transcript';
import MappingRatingModal from '../../modals/mapping-rating';
import AssignTeacherModalContainer from '../../modals/assign-teacher-wrapper';
import WorkbookDispatchedUploadModal from '../../modals/workbook-dispatched-upload';
import { MODAL_FORM } from '../../constants/form';
import AutoMappingModal from '../../modals/auto-mapping-modal';
import MapperMappingModal from '../../modals/mapper-mapping-modal';
import AssignTeacherToLead from '../../modals/assign-teacher-to-lead';
import AcLedMappingTeachersModal from '../../modals/ac-led-mapping-teachers-modal';
import EditTeacherLicenseModal from '../../modals/edit-teacher-license-modal';
import BookTrialClassModal from '../../modals/book-trial-class-modal';
import AcLedMappingBasicConfirmationModal from '../../modals/ac-led-mapping-basic-confirmation-modal';
import AcLedMappingResultFeedbackModal from '../../modals/ac-led-mapping-result-feedback';
import StudentTransferInitiateForm from '../../modals/student-transfer-modals/st-form';
import StudentTransferLoadScreens from '../../modals/student-transfer-modals/st-load-screen';
import StudentCourseDowngradeModal from '../../modals/student-course-downgrade-info';
import CSMAssignmentModal from '../../modals/csm-assignment-modal';
import PauseUnitsModal from '../../modals/add-pause-units';
import ChangeCrmParent from '../../modals/change-crm-parent';
import ChangeCrmGrade from '../../modals/change-crm-grade';
import TransferReasonUpdate from '../../modals/student-transfer-modals/transfer-reason-update';
import AssignTeacherToSATDemo from '../../modals/student-demo/assign-teacher-to-sat-demo';
import Maintenance from '../../modals/maintenance';
import PaymentFlowOverridesModal from '../../modals/payment-flow-overrides-modal';
import PaymentFlowGuideModal from '../../modals/payment-flow-guide-modal';
import RegionPayoutBulkConfirmModal from '../../modals/region-payout-bulk-confirm';
import RegionPayoutEditEndModal from '../../modals/region-payout-edit-end';

const MODALS = {
  addNewActivityCard: AddNewActivityCardModel,
  addSheetModal: AddSheetModal,
  addTopicModal: AddTopicModal,
  assignTeacherModal: AssignTeacherModal,
  assignTeacherModalContainer: AssignTeacherModalContainer,
  assignTeacherToLead: AssignTeacherToLead,
  bulkRMAssignmentModal: BulkRMAssignmentModal,
  confirmationModal: ConfirmationModal,
  createNewActivityModal: CreateNewActivityModal,
  courseClassLogActionModal: CourseClassLogActionModal,
  changeCrmParent: ChangeCrmParent,
  changeCrmGrade: ChangeCrmGrade,
  demoIncentives: DemoIncentives,
  demoSlotCreationModal: DemoSlotCreationModal,
  editActivityModal: EditActivityModal,
  editFilterModal: EditFilterModal,
  editStudentRegion: EditStudentRegion,
  editStudentSlotModal: EditStudentSlotModal,
  editStudentUsernameModal: EditStudentUsernameModal,
  editStudentPhoneModal: EditStudentPhoneModal,
  editStudentEmailModal: EditStudentEmailModal,
  electiveCoursesModal: ElectiveCoursesModal,
  foundationPaymentModal: FoundationPaymentModal,
  newPaymentModal: NewPaymentModal,
  onlinePlansPricingManagementModal: OnlinePlansPricingManagementModal,
  workbookDispatchedUploadModal: WorkbookDispatchedUploadModal,
  parentStudentModal: ParentStudentModal,
  paymentConfirmModal: PaymentConfirmModal,
  paymentDataModal: PaymentDataModal,
  paymentModal: PaymentModal,
  phoneModal: PhoneModal,
  relationshipManagerModal: RelationshipManagerModal,
  reviewConfirmModal: ReviewConfirmModal,
  reviewTypeModal: ReviewTypeModal,
  searchFilterModal: SearchFilterModal,
  studentCourseEditModal: StudentCourseEditModal,
  studentCourseLogModal: StudentCourseLogModal,
  studentForm: StudentFormModal,
  studentPaymentModal: StudentPaymentModal,
  studentUpgradeModal: StudentUpgradeModal,
  studentUpgradeV2Modal: StudentUpgradeV2Modal,
  studentTransferClassesModal: StudentTransferClassesModal,
  studentConvertClassesToCreditModal: StudentConvertClassesToCreditModal,
  studentCourseDowngradeModal: StudentCourseDowngradeModal,
  studentRevertUpgradePaymentLinkModal: StudentRevertUpgradePaymentLinkModal,
  studentTrialUpgradeModal: StudentTrialUpgradeModal,
  table: TableModal,
  teacherCredForm: TeacherCredForm,
  successModal: SuccessModal,
  bulkEditmodal: BulkEditmodal,
  teacherForm: TeacherFormModal,
  transcriptModal: TranscriptModal,
  updateDemoModal: UpdateDemoModal,
  mappingRatingModal: MappingRatingModal,
  [MODAL_FORM.AUTO_MAPPING_MODAL]: AutoMappingModal,
  [MODAL_FORM.MAPPER_MAPPING_MODAL]: MapperMappingModal,
  [MODAL_FORM.AC_LED_MAPPING_TEACHERS_MODAL]: AcLedMappingTeachersModal,
  [MODAL_FORM.EDIT_TEACHER_LICENSE_MODAL]: EditTeacherLicenseModal,
  [MODAL_FORM.AC_LED_MAPPING_BOOK_TRIAL_CLASS_MODAL]: BookTrialClassModal,
  [MODAL_FORM.AC_LED_MAPPING_BASIC_CONFIRMATION_MODAL]: AcLedMappingBasicConfirmationModal,
  [MODAL_FORM.AC_LED_MAPPING_RESULT_FEEDBACK_MODAL]: AcLedMappingResultFeedbackModal,
  [MODAL_FORM.CSM_ASSIGNMENT_MODAL]: CSMAssignmentModal,
  [MODAL_FORM.PAUSE_UNITS_MODAL]: PauseUnitsModal,
  [MODAL_FORM.ASSIGN_TEACHER_TO_SAT_DEMO]: AssignTeacherToSATDemo,
  [MODAL_FORM.PAYMENT_FLOW_OVERRIDES]: PaymentFlowOverridesModal,
  [MODAL_FORM.PAYMENT_FLOW_GUIDE]: PaymentFlowGuideModal,
  [MODAL_FORM.REGION_PAYOUT_BULK_CONFIRM_MODAL]: RegionPayoutBulkConfirmModal,
  [MODAL_FORM.REGION_PAYOUT_EDIT_END_MODAL]: RegionPayoutEditEndModal,
};

const WEB_COMPS_MODALS = {
  'student-transfer-initiate-form': StudentTransferInitiateForm,
  'student-transfer-load-screen': StudentTransferLoadScreens,
  'student-transfer-reason-update': TransferReasonUpdate,
  'maintenance': Maintenance,
};

class ModalContainer extends PureComponent {
  static getDerivedStateFromProps({ history }) {
    return {
      pathname: history.location.pathname,
    };
  }

  static defaultProps = {
    modal: null,
  };

  static propTypes = {
    modal: PropTypes.shape({
      name: PropTypes.string,
      options: PropTypes.object,
      props: PropTypes.object,
    }),
    actions: PropTypes.shape({
      openModal: PropTypes.func.isRequired,
      closeModal: PropTypes.func.isRequired,
    }).isRequired,
  };

  state = {
    pathname: null,
  };

  componentDidUpdate(prevProps, prevState) {
    const { modal } = this.props;
    const { pathname } = this.state;

    if (modal && pathname !== prevState.pathname) {
      this.onClose();
    }
  }

  onClose = () => {
    const { actions } = this.props;

    actions.closeModal();
  };

  render() {
    const { modal } = this.props;
    const { name: modalName, options } = modal || {};
    const { onClose: webCompModalClose } = options || {};

    if (WEB_COMPS_MODALS[modalName]) {
      return (
        <WebCompsModal
          modals={WEB_COMPS_MODALS}
          modal={modal}
          onClose={webCompModalClose || this.onClose}
        />
      );
    }

    return <Modal modals={MODALS} modal={modal} onClose={this.onClose} />;
  }
}

export default withRouter(
  connect(
    ({ modal }) => ({ modal }),
    dispatch => ({
      actions: bindActionCreators({ openModal, closeModal }, dispatch),
    }),
  )(ModalContainer),
);
